module.exports = __webpack_public_path__ + "static/media/mtvguru.3325a0c0.png";